import SidebarLayout from '../../components/SidebarLayout';
import AddActionForm from '../../components/sections/MTSS/AddActionForm';
import AccessWrapper from '../../components/AccessWrapper';
import AuthContext from '../../context/AuthContext';
import React, { useEffect, useContext } from 'react';

export default function AddAction() {
  const { postPageView, user, baseUrl } = useContext(AuthContext);

  useEffect(() => {
    postPageView(baseUrl, user.name, user.role, 'form/add-action');
  }, []);
  return (
    <AccessWrapper
      allowedGroups={[
        'teacher',
        'mtss_member',
        'mtss_supervisor',
        'mtss_admin',
        'district_admin',
      ]}
    >
      <div>
        <SidebarLayout
          propComponents={<AddActionForm />}
          heading={'Add Action'}
        />
      </div>
    </AccessWrapper>
  );
}
